module.exports = __webpack_public_path__ + "assets/img/order-count-icon1.bbbae989.png";